import { Link } from "react-router-dom";

const StatusCard = ({ children, to }) => (
  <Link to={to} className="group block">
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition hover:border-accent hover:shadow-md">
      {children}
    </div>
  </Link>
);

export default StatusCard;
